// Customizable Area Start
import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const MainWrapper = styled(Box)({
  display: "flex",
  placeItems: "center",
  flexDirection: "column",
  gap: "8px",
});

const CardWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  height: "164px",
  width: "164px",
  borderRadius: "30px 30px 30px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& > div": {
    height: "100px",
    width: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "30px 30px 30px 0px",
    boxShadow:
      "4px 4px 30px 0px #D1D9E6 inset, -4px 4px 30px 0px #FFFFFF80 inset",
    "& > img": {
      height: "45px",
      width: "45px",
    },
  },
  [theme.breakpoints.down("lg")]: {
    height: "140px",
    width: "140px",
    "& > div": {
      height: "90px",
      width: "90px",
      "& > img": {
        height: "35px",
        width: "35px",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    height: "110px",
    width: "110px",
    "& > div": {
      height: "70px",
      width: "70px",
      "& > img": {
        height: "30px",
        width: "30px",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    height: "134px",
    width: "134px",
    "& > div": {
      height: "80px",
      width: "80px",
      "& > img": {
        height: "30px",
        width: "30px",
      },
    },
  },
}));

const Heading = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 600,
  lineHeight: "29.26px",
  textAlign: "center",
  marginTop: "8px",
  [theme.breakpoints.down("md")]: {
    fontSize: "1.25rem",
    lineHeight: "24.38px",
  },
}));

interface IArtistStepsCardProps {
  icon: string;
  heading: string;
}

export class ArtistStepsCard extends Component<IArtistStepsCardProps> {
  render() {
    const { icon, heading } = this.props;
    return (
      <MainWrapper>
        <CardWrapper>
          <Box>
            <img src={icon} alt="Icon" loading="lazy" />
          </Box>
        </CardWrapper>
        <Heading>{heading}</Heading>
      </MainWrapper>
    );
  }
}

export default ArtistStepsCard;
// Customizable Area End
